import { Text, Flex, Heading, Image } from "@chakra-ui/react";
import ContactMe from "../../../../components/contact-me/ContactMe";
import DownloadCV from "../../../../components/download-cv/DownloadCV";
import FloatingStat from "../../../../components/floating-stat/FloatingStat";
import SocialIcons from "../../../../components/social-icons/SocialIcons";

const Hero = (): JSX.Element => {
  return (
    <Flex
      width={"100%"}
      align={"center"}
      direction={{ base: "column", md: "row" }}
    >
      <Flex
        width={"100%"}
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"center"}
        gap={3}
      >
        <Heading size={"lg"}>Manish Parui</Heading>
        <Text maxWidth={450} textAlign={"center"}>
          Senior Software Engineer | Frontend Engineer
        </Text>
        <Text maxWidth={450} textAlign={"center"}>
          5 years of expertise in building scalable, high-performance web apps.
          Passionate about creating intuitive, responsive user interfaces that
          enhance user experience.
        </Text>
        <Flex gap={6} marginTop={12} wrap={"wrap"} justifyContent={"center"}>
          <ContactMe />
          <DownloadCV />
        </Flex>
      </Flex>
      <Flex
        width={"100%"}
        marginTop={{ base: 100, md: 0 }}
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"center"}
        gap={100}
      >
        <Flex
          justifyContent={"center"}
          alignItems={"center"}
          position="relative"
        >
          <Image
            width={{ base: "100%", md: "75%" }}
            src="/undraw_programming_65t2-removebg-preview.png"
          />
          <FloatingStat
            bottom={{ base: "10%", md: "10%" }}
            left={{ base: "0%", md: "10%" }}
            delay={0}
            text={"3 Skills"}
          />
          <FloatingStat
            top={{ base: "0%", md: "0%" }}
            left={{ base: "10%", md: "20%" }}
            delay={1}
            text={"5 Clients"}
          />
          <FloatingStat
            top={{ base: "30%", md: "40%" }}
            right={{ base: "0%", md: "10%" }}
            delay={2}
            text={"10+ Projects"}
          />
        </Flex>
        <SocialIcons />
      </Flex>
    </Flex>
  );
};

export default Hero;
